// extracted by mini-css-extract-plugin
export default {"button":"scrollButton_button__M4nO0","show":"scrollButton_show__rLWeX","hidden":"scrollButton_hidden__-CHXm"};